/* "Wat past bij ons gezin" (0023, docs/DESIGN.md §8.P): chips (>= 48 px, meerkeuze, lopen door
   op 390 px), schakelaars voor bijzondere dagen, de voorstelkaart, het toestemmingsblok en de vaste
   opslagbalk. Rustig: geen rood, geen uitroeptekens; het accent alleen voor wat aan staat. */

.fieldset {
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
}

.legend {
  margin: 0 0 var(--space-1);
  padding: 0;
  font-size: var(--text-xl);
  font-weight: 600;
}

.legendQuiet {
  margin: 0 0 var(--space-2);
  padding: 0;
  color: var(--text-muted);
  font-size: var(--text-md);
  font-weight: 400;
}

.body {
  margin: 0 0 var(--space-3);
  color: var(--text-muted);
}

.hint {
  display: flex;
  gap: var(--space-2);
  margin: 0 0 var(--space-3);
  padding: var(--space-2) var(--space-3);
  border-radius: var(--radius-md);
  background: var(--info-tint);
  color: var(--text);
  font-size: var(--text-sm);
}

.hint svg {
  flex: 0 0 auto;
  margin-top: 2px;
  color: var(--info);
}

.chips {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
  margin: 0;
  padding: 0;
}

.chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  /* Fijnslijpen: de knopmaat van het ontwerpsysteem (44), niet 48. */
  min-height: var(--b-control);
  padding: 0 var(--space-3);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-pill);
  background: var(--surface-panel);
  color: var(--text);
  font: inherit;
  font-weight: 600;
  cursor: pointer;
}

.chip:hover {
  background: var(--surface-hover);
}

.chip[aria-checked='true'] {
  border-color: var(--accent);
  background: var(--accent-tint);
  color: var(--accent);
}

.chip:focus-visible {
  outline: 3px solid var(--focus-ring);
  outline-offset: 2px;
}

.chipCheck {
  display: inline-flex;
  margin-inline-start: -4px;
}

.shows {
  margin: var(--space-2) 0 0;
  color: var(--text-muted);
  font-size: var(--text-sm);
}

.sub {
  margin-top: var(--space-3);
}

.subTitle {
  margin: 0 0 var(--space-2);
  font-size: var(--text-md);
  font-weight: 600;
}

/* Voorstelkaart: een regio met kop; platte tekst, nooit voorgevinkt. */
.suggestion {
  margin: var(--space-3) 0;
  padding: var(--space-3);
  border: 1.5px solid var(--accent);
  border-radius: var(--radius-lg);
  background: var(--surface-panel);
}

.suggestionTitle {
  margin: 0;
  font-size: var(--text-xl);
  font-weight: 600;
}

.suggestionWhat {
  margin: var(--space-1) 0 var(--space-1);
  font-size: var(--text-lg);
  font-weight: 600;
}

.suggestionNote {
  margin: 0 0 var(--space-2);
  color: var(--text-muted);
  font-size: var(--text-sm);
}

.stack {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  margin-top: var(--space-3);
}

@media (min-width: 600px) {
  .stack {
    flex-direction: row;
  }
}

/* Bijzondere dagen: rijen met een schakelaar (UIT), voorvertoning en "Kies per dag". */
.dayList {
  display: grid;
  gap: 0;
  margin: 0;
  padding: 0;
  list-style: none;
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  background: var(--surface-panel);
}

.dayRow {
  padding: var(--space-3);
}

.dayRow + .dayRow {
  border-top: 1px solid var(--border-subtle);
}

.dayHead {
  display: flex;
  align-items: flex-start;
  gap: var(--space-3);
}

.dayText {
  flex: 1 1 auto;
  min-width: 0;
}

.dayName {
  display: block;
  font-weight: 600;
}

.dayPreview {
  display: block;
  margin-top: 2px;
  color: var(--text-muted);
  font-size: var(--text-sm);
}

/* UX-ronde 2: de knop zelf is het tikdoel (56 × 44 px); het spoor (56 × 32) en het bolletje zijn
   getekend met ::before en ::after. */
.switch {
  position: relative;
  flex: 0 0 auto;
  width: 56px;
  height: 44px;
  margin: 2px 0;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
}

.switch::before {
  content: '';
  position: absolute;
  top: 6px;
  inset-inline-start: 0;
  width: 56px;
  height: 32px;
  box-sizing: border-box;
  border: 1.5px solid var(--border-strong);
  border-radius: var(--radius-pill);
  background: var(--surface-sunken);
}

.switch::after {
  content: '';
  position: absolute;
  top: 10.5px;
  inset-inline-start: 4.5px;
  width: 23px;
  height: 23px;
  border-radius: 50%;
  background: var(--border-strong);
}

.switch[aria-checked='true']::before {
  border-color: var(--accent-fill);
  background: var(--accent-fill);
}

.switch[aria-checked='true']::after {
  inset-inline-start: 28.5px;
  background: var(--on-accent-fill);
}

.switch:focus-visible {
  outline: 3px solid var(--focus-ring);
  outline-offset: 2px;
  border-radius: var(--radius-pill);
}

.perDay {
  display: grid;
  gap: 0;
  margin: var(--space-2) 0 0;
  padding: 0;
  list-style: none;
}

.perDayRow {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  min-height: 48px;
}

.perDayName {
  flex: 1 1 auto;
  min-width: 0;
}

.linkButton {
  min-height: 44px;
  margin-top: var(--space-1);
  padding: 0;
  border: 0;
  background: none;
  color: var(--accent);
  font: inherit;
  font-weight: 600;
  text-decoration: underline;
  text-underline-offset: 3px;
  cursor: pointer;
}

.linkButton:focus-visible {
  outline: 3px solid var(--focus-ring);
  outline-offset: 2px;
}

.icsRow {
  display: flex;
  align-items: flex-start;
  gap: var(--space-3);
  margin-top: var(--space-3);
}

/* Toestemming "Mag dit?": nooit voorgevinkt, rustig omlijnd. */
.consent {
  margin: var(--space-4) 0 0;
  padding: var(--space-3);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  background: var(--surface-sunken);
}

.consentTitle {
  margin: 0 0 var(--space-1);
  font-size: var(--text-lg);
  font-weight: 600;
}

.consentText {
  margin: 0 0 var(--space-2);
  font-size: var(--text-sm);
  line-height: var(--line-normal);
}

/* Vaste opslagbalk onderaan (op de telefoon boven de tabbalk). Fixed: hij staat altijd in beeld,
   ook als het formulier korter is dan het scherm. De spacer houdt de laatste inhoud boven de balk. */
.saveSpacer {
  height: 132px;
}

.saveBar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: var(--z-sticky);
  padding: var(--space-3) var(--space-3) max(var(--space-3), env(safe-area-inset-bottom));
  border-top: 1px solid var(--border-subtle);
  background: var(--surface-panel);
  box-shadow: var(--shadow-1);
}

.saveBarInner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2);
  max-width: 640px;
  margin: 0 auto;
}

.saveBarNote {
  flex: 1 1 100%;
  margin: 0;
  color: var(--text-muted);
  font-size: var(--text-sm);
}

.saveBarInner > :global(button) {
  flex: 1 1 auto;
  justify-content: center;
}

@media (max-width: 1023px) {
  .saveBarAboveTabs {
    bottom: calc(70px + env(safe-area-inset-bottom));
    padding-bottom: var(--space-3);
  }
}

@media (min-width: 1024px) {
  .saveBarAboveTabs {
    inset-inline-start: 264px;
  }
}

/* Instellingen: blokken onder elkaar met een kop. */
.block {
  margin-top: var(--space-5);
}

.blockTitle {
  margin: 0 0 var(--space-2);
  padding-bottom: var(--space-1);
  border-bottom: 1px solid var(--border-subtle);
  font-size: var(--text-xl);
  font-weight: 600;
}

.consentList {
  margin: 0 0 var(--space-2);
  padding-inline-start: 1.25em;
  font-size: var(--text-sm);
  line-height: var(--line-normal);
}

.consentList li + li {
  margin-top: var(--space-1);
}

.privacyLink {
  font-weight: 600;
}

.privacyLine {
  display: flex;
  gap: var(--space-2);
  align-items: flex-start;
  margin: 0 0 var(--space-3);
  color: var(--text-muted);
  font-size: var(--text-sm);
}

/* Ledenrijen: twee regels, hele rij tikbaar. */
.memberList {
  margin: 0;
  padding: 0;
  list-style: none;
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  background: var(--surface-panel);
}

.memberList li + li {
  border-top: 1px solid var(--border-subtle);
}

.memberRow {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  width: 100%;
  min-height: 64px;
  padding: var(--space-2) var(--space-3);
  border: 0;
  background: none;
  color: var(--text);
  font: inherit;
  text-align: start;
  cursor: pointer;
}

.memberRow:hover {
  background: var(--surface-hover);
}

.memberRow:focus-visible {
  outline: 3px solid var(--focus-ring);
  outline-offset: -3px;
}

.memberText {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-width: 0;
}

.memberName {
  font-weight: 600;
}

.memberLine {
  color: var(--text-muted);
  font-size: var(--text-sm);
}

.consentFacts {
  margin: 0 0 var(--space-2);
}

.card {
  margin: 0 0 var(--space-4);
}

/* Uitnodiging op Vandaag: compact, onder agenda en taken (review d-ux r1). */
.compactCard {
  display: flex;
  align-items: flex-start;
  margin: 0 0 var(--space-4);
  padding: var(--space-3);
}

.compactCard > :first-child {
  flex: 0 0 auto;
  margin-inline-end: var(--space-3);
}

.compactText {
  flex: 1 1 auto;
  min-width: 0;
}

.compactTitle {
  margin: 0;
  font-weight: 600;
}

.compactBody {
  margin: var(--space-1) 0 var(--space-2);
  color: var(--text-muted);
  font-size: var(--text-sm);
}

.compactActions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2);
}

/* Kop van de wizardstap: teller links (mag afbreken), "Later doen" altijd rechts op dezelfde regel,
   ook in WebKit op 390 px met bredere systeemletters (review d-ux r2). */
.stepHead {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-2);
}

.stepCount {
  flex: 1 1 auto;
  min-width: 0;
  margin: 0;
}

/* Een deel van de teller ("vraag 1 van 4") breekt nooit midden in. */
.nowrap {
  white-space: nowrap;
}

.stepHead > :last-child {
  flex: 0 0 auto;
}

/* Golf 2: een bevestigde dag (aria-pressed) ziet eruit als een gekozen chip. */
.chip[aria-pressed='true'] {
  border-color: var(--accent);
  background: var(--accent-tint);
  color: var(--accent);
}

/* Golf 2: welke kalender voor de islamitische dagen, en de dagen die nog niet vast staan. */
.tradition {
  margin: var(--space-3) 0 var(--space-1);
  padding: var(--space-3);
  border-radius: var(--radius-md);
  background: var(--surface-sunken);
}

.confirm {
  margin-top: var(--space-3);
}

.confirmList {
  display: grid;
  gap: var(--space-2);
  margin: var(--space-2) 0 0;
  padding: 0;
  list-style: none;
}

.confirmRow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-2);
}

.confirmName {
  flex: 1 1 180px;
  min-width: 0;
  font-weight: 600;
}

.confirmChips {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
}

/* Golf 6b: gewoontes bij het gekozen geloof (optioneel, niets voorgevinkt). */
.practices {
  margin: var(--space-3) 0 0;
  padding: 0;
  border: 0;
}

/* Golf 6c: de mazhab na de gewoontes (alleen bij Islam, optioneel). */
.madhab {
  margin: var(--space-4) 0 0;
  padding: 0;
  border: 0;
}

.madhabHint {
  margin-top: var(--space-2);
}

.practicesTitle {
  margin: 0;
  padding: 0;
  font-weight: 600;
}
